"use strict";

exports.__esModule = true;
var _DeviceCycleCollector = require("./DeviceCycleCollector");
Object.keys(_DeviceCycleCollector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceCycleCollector[key]) return;
  exports[key] = _DeviceCycleCollector[key];
});